import { Trans } from 'react-i18next';

import type { ServiceNamespace } from 'src/locales/langs';
import { mergeClasses } from 'src/utils/merge-classes';

import { Reveal } from './reveal';
import { StarSky } from './star-sky';

type ManifestoNamespace = 'home' | 'about' | ServiceNamespace;

type ManifestoProps = {
  ns: ManifestoNamespace;
  compact?: boolean;
};

export function Manifesto({ ns, compact = false }: ManifestoProps) {
  return (
    <section className={mergeClasses('manifesto', compact && 'compact')}>
      {!compact && <StarSky />}
      <Reveal className="container">
        <p>
          <Trans
            ns={ns}
            i18nKey="manifesto"
            components={{
              accent: <span className="accent" />,
              dawn: <span className="dawn-word" />,
            }}
          />
        </p>
      </Reveal>
    </section>
  );
}
